import {AfterViewInit, Component, EventEmitter, Inject} from "@angular/core";
import {AbstractProdForm, ProdFormField, ProdFormFieldType, ProdFormValidators, RequiredValidator} from 'prod-form';
import {ProdDialogData} from 'prod-dialog';
import {IProdMap, MarkerAddressPoint, MarkerDropped, ProdMarker} from 'prod-map';
import {AbstractProdSelectService} from 'prod-select';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrganizationTreeSelect} from "../../../../dip/organization-tree-select";
import {OrganizationMapTemplate} from "../../../../dip/map/template/organization-map-template";
import {OrganizationService} from "../../../../services/organization.service";
import {Role} from "../../../../dip/role";
import {RoleService} from "../../../../services/role.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-site-form',
  templateUrl: './site-form.html'
})

export class SiteForm extends AbstractProdForm implements IProdMap, AfterViewInit {
  siteTitle: string = this.translate.instant('site.form.title');
  mapTitle: string = this.translate.instant('site.form.map_title');
  mapName: string = 'siteFormMap';
  markers$: EventEmitter<Map<number, ProdMarker>> = new EventEmitter<Map<number, ProdMarker>>();
  isFieldsEditable: boolean = this.roleService.hasRole([Role.ROLE_SITE_EDIT]);
  fields: ProdFormField[] = [
    ProdFormField.create({
      name: 'name',
      label: this.translate.instant('site.form.name'),
      type: ProdFormFieldType.TEXT,
      validators: new ProdFormValidators([
        new RequiredValidator()
      ]),
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: 'description',
      label: this.translate.instant('site.form.description'),
      type: ProdFormFieldType.TEXTAREA,
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: 'address',
      label: this.translate.instant('site.form.address'),
      type: ProdFormFieldType.ADDRESS,
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: 'latitude',
      label: this.translate.instant('site.form.latitude'),
      type: ProdFormFieldType.NUMBER,
      value: this.organizationTreeSelect.company.latitude,
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: 'longitude',
      label: this.translate.instant('site.form.longitude'),
      type: ProdFormFieldType.NUMBER,
      value: this.organizationTreeSelect.company.longitude,
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: 'organization',
      label: '',
      type: ProdFormFieldType.HIDDEN,
      value: this.organizationTreeSelect.company.id,
      isEditable: false
    }),
    ProdFormField.create({
      name: 'organizationType',
      label: '',
      type: ProdFormFieldType.HIDDEN,
      value: 2, // Site
      isEditable: false
    }),
  ];

  constructor(dialogRef: MatDialogRef<SiteForm>,
              @Inject(MAT_DIALOG_DATA) public dialogData: ProdDialogData,
              override dataService: OrganizationService,
              private organizationTreeSelect: OrganizationTreeSelect,
              private prodSelectService: AbstractProdSelectService,
              private roleService: RoleService,
              private translate: TranslateService) {
    super();
  }

  ngOnInit() {
    this.data.formResponseEvent.subscribe(() => {
      this.organizationTreeSelect.organizationTreeUpdate$.emit();
    });
  }

  ngAfterViewInit(): void {
    const markers: Map<number, ProdMarker> = new Map();
    if (this.dialogData.data.records) {
      this.dialogData.data.records.getAll().forEach(organization => {
        markers.set(organization['id'], new ProdMarker({
            id: organization['id'],
            name: organization['name'],
            lat: organization['latitude'],
            lng: organization['longitude'],
            icon: OrganizationMapTemplate.getIcon(organization),
            tooltip: OrganizationMapTemplate.getTooltip(organization),
            popup: OrganizationMapTemplate.getPopup(organization),
            pulse: false,
            radius: 0
          }
        ));
      });
    } else {
      markers.set(0, this.getDummyOrganizationMarker());
    }

    this.markers$.emit(markers);
  }

  prodMapEvents(event) {
    switch (event.constructor.name) {
      case MarkerDropped.name: {
        const value = <MarkerDropped>event;
        this.prodSelectService.selectValue.next({field: 'latitude', values: value.latLng.lat});
        this.prodSelectService.selectValue.next({field: 'longitude', values: value.latLng.lng});
        break;
      }
      case MarkerAddressPoint.name: {
        const value = <MarkerAddressPoint>event;
        this.prodSelectService.selectValue.next({field: 'address', values: value.address});
      }
    }
  }

  private getDummyOrganizationMarker(): ProdMarker {
    return new ProdMarker({
        id: 0,
        name: '',
        radius: 0,
        pulse: false,
        lng: this.organizationTreeSelect.company.longitude,
        lat: this.organizationTreeSelect.company.latitude,
        icon: OrganizationMapTemplate.getIcon(this.organizationTreeSelect.company),
        tooltip: '',
        popup: ''
      }
    );
  }
}
